import React from 'react';
import { useSelector } from 'react-redux';
import DropDown from '../../../../../ui/dropDown/DropDown';
import classes from './ScoreboardHouse.module.css';

const ScoreboardHouseSelectTab = ({ filters = [], onFilterChange, activeFilterId }) => {
    
    const { texts } = useSelector((state) => state.translate);
    const labelFor = (filter) => (filter.titleKey ? texts[filter.titleKey] : filter.title) ?? '';

    const activeFilter = filters.find((f) => f.id === activeFilterId) ?? filters[0];
    const dropdownValue = activeFilter ? labelFor(activeFilter) : '';
    const dropdownOptions = filters.map((filter) => ({
        key: String(filter.id),
        value: labelFor(filter),
        onClick: () => onFilterChange?.(filter.id),
    }));
    //chack remove text district from texts

    return (
        <div className={classes.filterContainer} >
            <div className={classes.filterContainerInner}>
            <div className={classes.filterTitle}>{texts?.districts}</div>
            <div className={classes.dropdownWrap}>
                <DropDown
                    options={dropdownOptions}
                    value={dropdownValue}
                    showValue
                    dropClass={classes.houseDropdown}
                    arrowColor="#070C43"
                    closeOnApply={false}
                    applyButtonText={texts?.selectHouse}
                    height="280px"
                />
            </div>
            </div>
        </div>
    );
};

export default ScoreboardHouseSelectTab;
